import api from './api_helper';

const BASE_URL = '/api/jobs';
export const notifyBackgroundJobStarted = () =>
  window.dispatchEvent(new Event('background-job-started'));

export const getActiveBackgroundJobs = () => api.get(`${BASE_URL}/active`);
export const getRecentBackgroundJobs = (limit = 20) =>
  api.get(`${BASE_URL}/recent`, { params: { limit } });
export const cancelBackgroundJob = id => api.post(`${BASE_URL}/${encodeURIComponent(id)}/cancel`);
export const retryBackgroundJob = id => api.post(`${BASE_URL}/${encodeURIComponent(id)}/retry`);
export const getBackgroundJobErrors = (id, page = 0, size = 50) =>
  api.get(`${BASE_URL}/${encodeURIComponent(id)}/errors`, { params: { page, size } });
